export default "__VITE_ASSET__1fc9186e__"